module.exports = "/assets/data/af3af355b48dac1568f2a8cb77b02289-BA4.data.json";